import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  centered?: boolean
  title?: string
  description?: string
}

const FieldSet = ({
  title,
  description,
  centered = false,
  children,
}: React.PropsWithChildren<Props>) => (
  <>
    <Box gap="s4" alignItems={centered ? 'center' : 'flexStart'}>
      {!!title && <Text.Header3>{title}</Text.Header3>}
      {!!description && <Text.Normal size="300">{description}</Text.Normal>}
    </Box>
    <Box paddingTop="s16">{children}</Box>
  </>
)

export default FieldSet
